import React, { useState, useEffect } from 'react';
import {
    Card, CardBody, Col, Nav, NavItem, NavLink,
    TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import { Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getMasterDataToken } from '../../../../Utils/restUtils';
import { getCompanyInvoice, getCompanyPayment, getShareApi } from '../../../../CommonURL';

const InvoicePayment = ({ param }) => {
    const style2 = { width: 85, fontSize: 13, padding: 5 };
    const navigate = useNavigate();
    const authState = useSelector(state => state.auth);

    const [activeTab, setActiveTab] = useState('1');
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const [invoiceList, setInvoiceList] = useState([]);
    const [paymentList, setPaymentList] = useState([]);
    const [loading, setLoading] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
   const InvoiceColumns = [
    { 
        name: <H4>Sl No</H4>, 
        selector: row => row.Si, 
        width: '80px' ,
        center:true
    },
     {
            name: <H4>Action</H4>,
            selector: row => row.action,
            sortable: true,
            width: '120px'

        },

    { 
        name: <H4>Company</H4>, 
        selector: (row) => (
              <Link
                to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.CompanyId}&user_id=${row.id}&industryId=${row.IndustryId}`}
                state={{
                  clientUrl: row.client_url,
                  industryName: row.Industry,
                }}
              > {row.Company }</Link> )
    },

    { 
        name: <H4>Invoice no</H4>, 
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.order_id}`}
          > {row.Invoice }</Link>),
    },

    // { 
    //     name: <H4>Invoice Type</H4>, 
    //     selector: row => row.InvoiceType 
    // },

    { 
        name: <H4>Billing Date</H4>, 
        selector: row => row.BillingDate ,
        wrap:true,
    },

    { 
        name: <H4>Total</H4>, 
        selector: row => row.Total 
    },

    { 
        name: <H4>Status</H4>, 
        selector: row => row.Status, 
         cell: row => (
                <span
                    className={`badge badge-${row.Status}`}
                >
                    {row.Status}
                </span>
            ),
    }
];

//    const PaymentColumns = [
//     { name: <H4>Sl</H4>, selector: row => row.Si, width: '60px' },
//     { name: <H4>Name</H4>, selector: row => row.Name ,wrap:true},
//     { name: <H4>Company</H4>, selector: row => row.Company, wrap:true},
//     { name: <H4>Industry</H4>, selector: row => row.Industry ,wrap:true},
//     { name: <H4>Invoice No</H4>, selector: row => row.InvoiceNo },
//     { name: <H4>Amount</H4>, selector: row => row.Amount },
//     { name: <H4>Paid At</H4>, selector: row => row.PaidAt },
//     { name: <H4>Method</H4>, selector: row => row.Method },
//     { name: <H4>Transaction ID</H4>, selector: row => row.TransactionId },
//     { name: <H4>Status</H4>, selector: row => row.Status }
// ];
 const paymentsColumns = [
    {
        name: <H4>Sl No</H4>,
        selector: row => row.Si,
        sortable: true,
        width: '80px',
        center: true,
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.Action,
        sortable: true,
        // center: true,
    },
    // {
    //     name: <H4>Comany</H4>,
    //     selector: row => row.Company,
    //     sortable: true,
    //     // center: true,
    // },
    {
        name: <H4>Paid On</H4>,
        selector: row => row.PaidAt,
        sortable: true,
        // center: true,
        wrap: true
    },
    {
        name: <H4>Txn Id</H4>,
        selector: row => row.TransactionId,
        sortable: true,
        // center: true,
        wrap: true


    },
    {
        name: <H4>Amount Collected</H4>,
        selector: row => row.Amount,
        sortable: true,
        // center: true,
        wrap: true,
        width: '120px'
    },
    {
        name: <H4>Industry Name</H4>,
        selector: row => row.Industry,
        sortable: true,
        center: true,
        width: '165px',
        wrap:true
    },
    {
        name: <H4>Payment Type</H4>,
        selector: row => row.Method,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        sortable: true,
        center: true,
        width: '135px'
    },
];

    useEffect(() => {
        fetchInvoices();
    }, []);
   const redirectToInvoice = async (row) => {
        // let response = await getMasterDataToken(getShareApi + `?order_id=${row.order_id}`);
        // if (response.data.status == true) {
        //     navigate(`${process.env.PUBLIC_URL}/invoice?order_id=${response.data.data}`);
        // }
        navigate(`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.order_id}`);
    };
    const redirectToReciept = (id) => {
        const toReciept = `${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${id}`;
        navigate(toReciept);
    };
    const fetchInvoices = async () => {
        setLoading(true);
        const res = await getMasterDataToken(getCompanyInvoice + `?user_id=${param}`);
       
       if (res?.data?.status === true) {
    setInvoiceList(
    res?.data?.data?.data?.map((e, i) => ({
        Si: i + 1,
        Company: e.company_name,          
        Invoice: e.invoice_number,
        InvoiceType: e.invoice_type,      
        BillingDate: e.billing_date,
        Total: `${authState?.currency ?? "₹"} ${e.total_amount}`,
        Status: e.payment_status,
        Industry: e.industry_name,                  
        CompanyId:e.company_id,
        client_url:e.client_url,
        id:e.user_id,
        IndustryId:e.industry_type_id,
        
        order_id: e.order_id,
          action:
          <div>
           <span>
            <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToInvoice(e) }}>View More</Btn>
           </span>
         </div>
    }))
);
} else {
    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
}
      setLoading(false);
    };

    const fetchPayments = async () => {
        setLoading(true);
        const res = await getMasterDataToken(getCompanyPayment + `?user_id=${param}`);

        if (res?.data?.status === true) {
           setPaymentList(
    res?.data?.data?.data?.map((e, i) => ({
        Si: i + 1,
        Name: e.user_name,                         
        Company: e.company_name,                    
        Industry: e.industry_name,                  
        InvoiceNo: e.invoice_number,                
        PaidAt: e.payment_date,
        Amount: `${authState?.currency ?? "₹"} ${e.paid_amount}`,
        Method: e.payment_method_name,             
        TransactionId: e.transaction_id,            
        Status: e.payment_status,
       
         Action:
          <div>
            <span>
             <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToReciept(e.id) }}>Reciept</Btn>
                </span>
        </div >
    }))
);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }

        setLoading(false);
    };

    

    return (
        <Col sm="12" xl="12">
            <Card>
                <CardBody>

                    {/* TABS */}
                    <Nav className="border-tab nav-primary" tabs>
                        <NavItem>
                            <NavLink
                                className={activeTab === '1' ? 'active' : ''}
                                onClick={() => setActiveTab('1')}
                                style={{ cursor: 'pointer' }}
                            >
                                Invoice
                            </NavLink>
                        </NavItem>

                        <NavItem>
                            <NavLink
                                className={activeTab === '2' ? 'active' : ''}
                                onClick={() => {setActiveTab('2');fetchPayments(); }}
                                style={{ cursor: 'pointer' }}
                            >
                                Payment
                            </NavLink>
                        </NavItem>
                    </Nav>

                    {/* TAB CONTENT */}
                    <TabContent activeTab={activeTab}>

                        {/* INVOICE TAB */}
                        <TabPane tabId="1">
                            <div className="order-history table-responsive" style={{ marginTop: '10px', width: '100%' }}>
                                <DataTable
                                    data={invoiceList}
                                    columns={InvoiceColumns}
                                    pagination
                                    highlightOnHover
                                    striped
                                    progressPending={loading}
                                />
                            </div>
                        </TabPane>

                        {/* PAYMENT TAB */}
                        <TabPane tabId="2">

                           
                            <div className="order-history table-responsive" style={{ marginTop: '10px', width: '100%' }}>
                                <DataTable
                                    data={paymentList}
                                    columns={paymentsColumns}
                                    pagination
                                    highlightOnHover
                                    striped
                                    progressPending={loading}
                                />
                            </div>
                        </TabPane>

                    </TabContent>
                </CardBody>
            </Card>
        </Col>
    );
};

export default InvoicePayment;

